<app-top-bar></app-top-bar>

<router-outlet></router-outlet>

<app-footer></app-footer>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="true">
  <p style="color: white">{{ 'loading' | translate }}</p>
</ngx-spinner>
